import { Injectable } from '@angular/core';
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { UserSessionService } from '../services/usersession.service';
import { NavigationService } from '../services/navigation.service';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router,
        private userSessionService: UserSessionService,
        private navigation: NavigationService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        let menuItems: any[] = [];
        const paths: any[] = [];
        const roleId = this.userSessionService.getValue('roleId');
        const isLoggedIn = localStorage.getItem('isLoggedin');
        const token = localStorage.getItem('token');

        console.log('isLoggedin value:', isLoggedIn);
        console.log('token value:', token);
        console.log('trying to access:', state.url);

        // Step 1 - Not logged in at all
        if (!isLoggedIn || !token || this.isTokenExpired(token)) {
            console.log('FAILED - not logged in or token expired');
            this.router.navigate(['/auth/login']);
            return false;
        }

        // Step 2 - Allow these routes always without menu check
        // const alwaysAllowed = ['/dashboard', '/landing', '/profile'];
        // if (alwaysAllowed.some(path => state.url.startsWith(path))) {
        //     console.log('ALLOWED - always allowed route');
        //     return true;
        // }

        // Step 3 - Check menu permissions
        const menu = this.userSessionService.getLocalStorageWithKey('menu');
        console.log('menu from storage:', menu);

        if (menu) {
            menuItems = JSON.parse(menu);
        }

        // Step 4 - No menu loaded yet, allow access
        // (menu might not be loaded on first login)
        if (!menuItems || menuItems.length === 0) {
            console.log('ALLOWED - no menu items loaded yet');
            return true; // ✅ dont block if menu not loaded yet
        }

        // Step 5 - Build paths from menu
        menuItems.forEach(field => {
            if (field.link) { paths.push(field.link); }
            if (field.subItems && field.subItems.length > 0) {
                field.subItems.forEach(sm => {
                    if (sm.link) { paths.push(sm.link); }
                });
            }
        });

        console.log('allowed paths from menu:', paths);

        // Step 6 - Exact path match
        if (paths.indexOf(state.url) >= 0) {
            console.log('ALLOWED - exact path match');
            return true;
        }

        // Step 7 - Partial path match (/users/123 → /users)
        const urls = state.url.split('/');
        console.log('url segments:', urls);
        if (urls.length > 1 && paths.indexOf('/' + urls[1]) >= 0) {
            console.log('ALLOWED - partial path match');
            return true;
        }

        // Step 8 - Path not in menu
        console.log('FAILED - path not in menu, redirecting to dashboard');
        if (roleId == 7)
            this.navigation.resellerapplication();
        else
            this.router.navigate(['/dashboard']);
        return false;
    }

    private isTokenExpired(token: string): boolean {
        try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            const valid: any = Math.floor(Date.now() / 1000) >= payload.exp;
            console.log("token expiered or not" + valid);

            return valid;
        } catch (e) {
            return true;
        }
    }
}